import { render, staticRenderFns } from "./devoirsDashTeacher.vue?vue&type=template&id=1b9e62d2&"
import script from "./devoirsDashTeacher.vue?vue&type=script&lang=js&"
export * from "./devoirsDashTeacher.vue?vue&type=script&lang=js&"
import style0 from "./devoirsDashTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports